"use strict";

/**
 * Диалог массового назначения прав доступа на документы.
 *
 * @class WebAccess.components.dialogs.EdmsObjectsRightsDialog
 * @extends WebAccess.components.dialogs.BaseDialog
 * @since 5.8.2.5000
 */
((global) => {
  class EdmsObjectsRightsDialog extends global.BaseDialog {
    constructor(settings) {
      super(settings);
      /**
       * @see BaseDialog.title
       * @see BaseDialog.width
       * @see BaseDialog.height
       * @property {string} className css-класс диалога
       * @property {object} _jWindow jQuery-объект диалогового окна
       * @see BaseDialog.isShowCancelButton
       * @see BaseDialog.id
       * @property {string} dialogSelector Селектор диалога для jQuery
       * @property {object} documentIds Список ссылок на документы формата {Objects: objects}, где objects – это WA.Link[]
       */
      this.title = L('MODAL_DIALOG_MASS_RIGHTS');
      this.width = 900;
      this.height = 600;
      this.className = 'EdmsObjectsRightsDialog';
      this._jWindow = null;
      this.isShowCancelButton = true;
      this.id = 'massrights_dialog';
      this.dialogSelector = `#${this.id}`;
    }

    /**
     * Сохраняет права доступа при нажатии на «ОК».
     * @method WebAccess.components.dialogs.EdmsObjectsRightsDialog#ok
     */
    ok() {
      const selectedRecords = $('#__SELECTED_USERS').val();
      const rightRecords = selectedRecords.split(';');
      let rights = [];
      for (let i = 0; i < rightRecords.length; i++) {
        const rightRecord = $.trim(rightRecords[i]);
        if (rightRecord) {
          const rightRecordInfo = rightRecord.split('-');
          let id = rightRecordInfo[0];
          let rightType = [ACCESS_RIGHTS.FULL, ACCESS_RIGHTS.CHANGE, ACCESS_RIGHTS.VIEW][parseInt(rightRecordInfo[1], 10)]; // 0 -> 16 (full), 1 -> 8 (change), 2 -> 4 (view)
          if (!rightType) {
            rightType = ACCESS_RIGHTS.EMPTY;
          }
          let isGroup = false;

          if (id.startsWith('g_')) {
            id = id.substr(2);
            isGroup = true;
          }
          rights.push(new AccessRightsEntryModel(id, isGroup, rightType));
        }
      }

      WA.SRV.access.applyEdmsRights(this.documentList, rights)
        .done((result) => {
          if (result && result.length > 0) {
            //Для отображения ошибки соберем данные детальной информации.
            let deniedReasons = [];
            $.each(result, (i, resultItem) => {
              if (!resultItem.IsSuccess) {
                if (resultItem.TargetObject.Name) {
                  deniedReasons.push(`${L("DOCUMENT")} "${resultItem.TargetObject.Name}" : ${resultItem.DeniedReason}`);
                } else {
                  deniedReasons.push(resultItem.DeniedReason);
                }
              }
            });

            if (deniedReasons.length > 0) {
              const errorDialog = new WA.CMP.dialogs.MessageBox();
              errorDialog.width = 600;
              errorDialog.showError(L('APPLY_ACCESS_RIGHTS_ERROR'), deniedReasons.join('<br/>'), L('ERROR'));
            } else {
              // Назначение прав прошло успешно.
              const toastMsg = new WA.CMP.notifications.Toast();
              toastMsg.show(L('INF_APPLY_MASS_RIGHTS'));
            }
          }
        })
    }

    /**
 * Инициализация jQuery объектов и навешивание на них событий, 
 * функция вызывается когда модальное окно и все его элементы загружены.
 * @method _postInit
 * @private
 */
    _postInit() {
      const jWindow = this._jWindow;
      //Отображаем сообщение о невозможности изменить права для некоторых объектов.
      if (jWindow.find('#CanChangeRights').val() === 'False') {
        this.inlineHint.showInfo(L('INF_CAN_NOT_CHANGE_MASS_RIGHTS'));
      }

      //Инициализируем пользователей и группы. Передаем в качестве ид объекта -1, чтобы для текущего окна не помечались пользователи из объединенного списка прав.
      UserRightInit('massRights', '-1', OBJECT_TYPE.EDOCUMENT, L('ENTER_USER_NAME_OR_GROUP_NAME'), true);
    }

  /**
   * Показывает окно для массовой установки прав доступа.
   * @function WebAccess.components.dialogs.EdmsObjectsRightsDialog.show
   * @param {object} documentIds Список ссылок на документы формата {Objects: objects}, где objects – это WA.Link[]
   */
    show(documentIds) {
      documentIds = documentIds || {};
      this.documentList = [];
      this.documentList = documentIds.Objects.map((item) => {
        return { id: item.ID, kind: 'EDOC' }
      })

      WA.SRV.call('/ModalWindow.asmx/Create', {
        ControlName: "mass_rights",
        Params: $.toJSON(documentIds)
      }).done((data) => {
        this.setHtml(`<div id=${this.id}>${data.html}</div>`);
        super.show();
        this._jWindow = $(this.dialogSelector);
        this._postInit();
        moveOpenedDialogToCenter();
      }).fail(() => {
        this.close();
      });
      return this;
    }
  }

  global.EdmsObjectsRightsDialog = EdmsObjectsRightsDialog;
})(window.WebAccess.components.dialogs);